import { useState, useEffect } from "react";
import { getBetasAsObservable } from "./betas.helpers";
import { handleError } from "src/handle-error.helper";

export function useBetas(betas = [], requireAll) {
  if (!betas || !betas.length) {
    console.warn("No betas were passed to `useBetas`");
  }
  const computeAccess = (tenantBetas) => {
    const checkBeta = (beta) => {
      return Array.isArray(tenantBetas)
        ? tenantBetas.some((tenantBeta) => beta === tenantBeta)
        : undefined;
    };
    if (typeof betas === "string") {
      return checkBeta(betas);
    }
    return requireAll ? betas.every(checkBeta) : betas.some(checkBeta);
  };

  const [access, setAccess] = useState(computeAccess(window?.betas));

  useEffect(() => {
    const subscription = getBetasAsObservable().subscribe((resp) => {
      const hasAccess = computeAccess(resp);
      setAccess(hasAccess);
    }, handleError);
    return () => subscription.unsubscribe();
  }, [`${betas}`, requireAll]); // eslint-disable-line react-hooks/exhaustive-deps
  // lint-td: has missing dependencies: 'betas'

  return access;
}
